import { useLocation, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { siteName, mainSiteUrl } from "@/mocks/categories";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20">
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
          <div className="relative">
            <h1 className="text-[8rem] md:text-[12rem] font-black text-background-200 select-none pointer-events-none leading-none">
              404
            </h1>
            <div className="absolute inset-0 flex items-center justify-center">
              <i className="ri-error-warning-line text-6xl md:text-8xl text-accent-200"></i>
            </div>
          </div>
          <div className="relative z-10 -mt-6">
            <h2 className="text-xl md:text-2xl font-semibold text-foreground-900 mt-6">
              Page Not Found
            </h2>
            <p className="mt-2 text-sm text-foreground-500 font-mono break-all max-w-md mx-auto">
              {location.pathname}
            </p>
            <p className="mt-4 text-base text-foreground-600 max-w-lg mx-auto">
              The page you are looking for does not exist or has been moved. Explore our guides and resources below.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
              <Link
                to="/"
                className="px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                Back to Homepage
              </Link>
              <Link
                to="/basetao-spreadsheet-guide"
                className="px-6 py-3 border border-accent-300 text-accent-700 font-medium text-sm rounded-md hover:bg-accent-100 transition-all whitespace-nowrap cursor-pointer"
              >
                Read Complete Guide
              </Link>
            </div>
            <div className="mt-6 text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} {siteName}. All rights reserved.
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}